export default __webpack_public_path__ + "static/media/jalapeno.89b650a6.JPG";